export const isVisible = (state, moduleId = "default") => {
  // return true if module is unknown
  if (moduleId in state.modules.showSidebar) {
    return state.modules.showSidebar[moduleId];
  }
  return true;
};
